import { KentAggressiveModeConfig } from '@cast/types-kent';
import { toNumOrUndefined } from '@cast/utils';
import isNumber from 'lodash/isNumber';

export const parseAggressiveModeDrainTimeoutSecondsToMinutes = (
  drainTimeoutSeconds: KentAggressiveModeConfig['drainTimeoutSeconds']
): number | undefined => {
  const parsedSeconds = toNumOrUndefined(drainTimeoutSeconds);

  if (isNumber(parsedSeconds)) {
    return parsedSeconds / 60;
  }

  return undefined;
};
